<template lang="pug">
  b-navbar.text-white(toggleable='lg', :class="{ 'scrolled': !atTopOfPage }")
    b-navbar-brand.d-md-none(:to="{name:'home'}")
      img.nav-brand-img(:src="atTopOfPage ? 'https://cdn.wallcollective.co/resources/branding/logo_co_light.svg' : 'https://cdn.wallcollective.co/resources/branding/logo_co_dark.svg'", alt="Wall collective logo")
    b-navbar-toggle.m-3(target='nav_collapse', style="border: none;")
    b-collapse#nav_collapse.p-2.row(is-nav='', v-model="navCollapse")
      .col-md-4
        b-navbar-brand.d-none.d-md-block(:to="{name:'home'}", aria-label="Wall collective home page")
          img.nav-brand-img(:src="atTopOfPage ? 'https://cdn.wallcollective.co/resources/branding/logo_co_light.svg' : 'https://cdn.wallcollective.co/resources/branding/logo_dark.svg'", alt="Wall collective logo")
      .col-md-8
        b-navbar-nav.justify-content-end.nav-1
              b-nav-item#btnArt(:to="{name: 'gallery'}") ARTWORKS
              b-nav-item(:to="{name: 'artists'}") ARTISTS
              b-nav-item(:to="{ name: 'consulting' }") CONSULTING & CURATION
              b-nav-item(:to="{ name: 'rentals' }") RENTALS
              b-nav-item(:to="{ name: 'about' }") ABOUT US
              b-nav-item#btnAccount(v-if="account.loggedIn", :to="{name:'AccountProfile'}")
                  b-avatar(variant="light", size="2rem", :text="`${account.user.firstname[0]}${account.user.lastname[0]}`")
              b-nav-item#btnCart(v-if="account.loggedIn", :to="{name:'cart'}")
                  font-awesome-icon(icon="shopping-cart", variant="text-danger", :class="{ favourite: cartCount > 0}")
              b-nav-item.btn-outline-light#btnLogin(v-if="!account.loggedIn", :to="{name:'login'}") LOGIN / REGISTER
              //div(v-if="account.loggedIn")
                b-nav-item#btnAccount(v-if="account.loggedIn", :to="{name:'AccountProfile'}")
                  b-avatar(variant="light", size="2rem", :text="`${account.user.firstname[0]}${account.user.lastname[0]}`")
                b-nav-item(:to="{name:'love'}")
                  font-awesome-icon.favourite(icon="heart")
                b-nav-item#btnCart(:to="{name:'cart'}")
                  font-awesome-icon(icon="shopping-cart", variant="text-danger", :class="{ favourite: cartCount > 0}")
              //div(v-else="")
                b-nav-item.btn-outline-light#btnLogin(:to="{name:'login'}") LOGIN / REGISTER
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'Navbar',
  mixins: [standardMix],
  data() {
    return {
      navCollapse: false,
      atTopOfPage: true,
    };
  },
  computed: {
    ...mapGetters('cart', ['cartCount']),
  },
  methods: {
    ...mapActions('account', ['logout']),
    handleScroll() {
      // Check if the vertical scroll position is 0 (top of page)
      if (window.pageYOffset > 0) {
        this.atTopOfPage = false;
      } else {
        this.atTopOfPage = true;
      }
    },
  },
  mounted() {
    // Add the event listener when the component is mounted
    window.addEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>

.nav-segment {
  flex-basis: 0;
  flex-grow: 1;
}
.navbar {
  width: 100%;
  position: fixed;
  z-index: 1000;
  top: 0%;
  left: 0;
  @media (min-width: 380px) {
    position: absolute;
  }
  // background-color: rgba(black, 0.5);
  .nav-item {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
    white-space: nowrap;
  }
  // .nav-content {
  //   // border-bottom: 1px solid rgba(black, 0.3);
  //   display: flex;
  //   justify-content: space-between;
  // }
  align-items: flex-end;
  .nav-link {
    // font-family: Belleza;
  }
  // border-bottom: 1px solid rgba(black, 0.3);
  // min-height: $navbar-height;
  // background-color: white;
  .navbar-collapse {
    // border-bottom: 1px solid rgba(black, 0.3);
    // background-color: white;
    &.show {
      .nav-1 {
        a {
          margin: 5px 0px 5px 0px;
          text-align: center;
          border: 1px solid rgba(black, 0.5);
        }
        ul {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }
      .nav-2 {
        ul {
          display: flex;
          justify-content: space-around;
          a {
            border-bottom: none
          }
        }
      }
    }
  }
}
  .nav-brand-img{
    height: 25px;
  }
  a{
    padding: 20px;
  }

  .navbar a{
    // font-size: 0.8rem;
    color: rgba(white, 0.8) !important;
    .favourite {
      color: darkgreen !important;
    }
  }
  // .b-nav-item-exact-active{
  //   border-bottom: 1px solid white;
  // }

  .navbar-brand {
    border-bottom: none;
  }

  nav {
  /* Default styles (e.g., transparent background at the top) */
  background-color: transparent;
  transition: background-color 0.4s ease-in-out; /* Smooth transition */
  position: fixed; /* Ensures navbar stays in place */
  width: 100%;
  z-index: 10;
  @media (max-width: 768px) {
  background-color: black;
}
  // @include phone {
  //     background-color: black;
  //   }
}

nav.scrolled {
  background: rgba(255, 255, 255, 0.1) !important; /* Semi-transparent white */
  backdrop-filter: blur(10px) !important;       /* The "frosted" effect */
  -webkit-backdrop-filter: blur(5px) !important; /* Safari support */
  color: black !important; /* Text color */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  transition: all 0.3s ease;
  a {
    color: black !important; /* Text color */
  }
  .btn-outline-light {
    border-color: black !important;
    color: black !important;
    &:hover {
      color: white !important;
      background-color: transparent !important;
    }
  }
}

.navbar-toggler-icon {
   background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>") !important;
}

</style>



// WEBPACK FOOTER //
// src/components/structure/Navbar.vue